export const HEADER_HEIGHT = 80;
export const HEADER_MOBILE_HEIGHT = 64;
